import React from "react";
import { serverResponse } from "../../../../util/fakeServer";

const PromoModal = ({ promos }) => {
  if (!promos) return null;

  const promoImages = Object.keys(promos).map((promoId) => {
    const promo = serverResponse.leaflet.attributes.promo[promoId];
    const childId = promos[promoId];

    if (childId) {
      return promo.children[childId].img;
    }
    return promo.img;
  });

  return (
    <div className="promo-block d-flex">
      {promoImages.map((imgSrc, index) => (
        <div key={index} className="promo-item">
          <img src={imgSrc} alt="Promo" className="h-100 w-100" />
        </div>
      ))}
    </div>
  );
};

export default PromoModal;
